import React from 'react';
import { IconProps } from './iconProps';
import { useTheme } from '@mui/material/styles';
import { defaultSpacingPresets } from 'hooks/useGetSpacing';
import cx from 'classnames';

export default function IconTriangle({
  onClick,
  extColor,
  sizeKey = '16x8',
  style,
}: IconProps) {
  const theme = useTheme();
  const fill = extColor || theme.palette.customBackgrounds.elevation6;

  const w = defaultSpacingPresets.icons[sizeKey].w;
  const h = defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      style={style}
      className={cx({ 'icon-disabled': !onClick })}
      onClick={onClick}
      width={w}
      height={h}
      viewBox="0 0 16 8"
      fill={fill}
    >
      <path d="M-0.000244141 7.99988L7.99976 -0.00012207L15.9998 7.99988L-0.000244141 7.99988Z" />
      <path
        d="M-0.000244141 7.99988L7.99976 -0.00012207L15.9998 7.99988L-0.000244141 7.99988Z"
        fillOpacity="0.8"
      />
    </svg>
  );
}
